import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { DepartmentService } from '../../services/jrni/department.service';
import { combineLatest, from, Observable, ReplaySubject, Subject, of } from 'rxjs';
import { map, switchMap, takeUntil } from 'rxjs/operators';
import { AmazonService } from '../../services/jrni/amazon.service';
import { AppConfig } from '../../app.config';
import { isEmailAddress } from './contact-info.validator';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../services/jrni/api.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '../../_alert';
import { DatastoreService } from '../../services/datastore.service';
import { AvailabilityService } from '../../services/jrni/availability.service';
import { BasketService } from '../../services/jrni/basket.service';
import { MemberService } from '../../services/jrni/member.service';
import { ServicesService } from '../../services/jrni/services.service';
import { environment } from 'apps/dorsetcouncil-hwrc-booking-service/src/environments/environment';
import {
  faIdCard,
  faCalendarCheck,
  faCar,
  faCalendar,
  faCheckCircle,
  faCircleCheck,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

@Component({
  selector: 'app-check-permit',
  templateUrl: './check-permit.component.html',
  styleUrls: ['./check-permit.component.scss'],
})
export class CheckPermitComponent implements OnInit, OnDestroy {

  checkPermitForm: FormGroup | undefined;
  sent = false;
  parentDepartment: any;
  selectedDepartment: any;
  selectedService: any;
  pageTitle: any;
  guidanceMsg: any;
  selectedLocation: any;
  dataTablesData: any = {}
  foundPermit: any;
  history: any;
  showingHistory: boolean = false;

  constructor(
    private router: Router,
    private servicesService: ServicesService,
    private departmentService: DepartmentService,
    private formBuilder: FormBuilder,
    private basketservice: BasketService,
    private alertService: AlertService,
    private translateService: TranslateService,
    private memberService: MemberService,
    public datastoreService: DatastoreService,
    private spinner: NgxSpinnerService,
    private apiService: ApiService,
    private amazonService: AmazonService,
    private availabilityService: AvailabilityService
  ) {
    console.log('this.datastoreService.config', this.datastoreService.config);
  }

  get bookingForm() {
    return this.checkPermitForm?.controls;
  }

  async ngOnInit(): Promise<void> {

    this.scrollToTop();
    this.checkPermitForm = this.formBuilder.group({
      registration: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.pattern('^[A-Z0-9]+$')],
      }),
      verificationCode: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required],
      }),
    });
    this.parentDepartment = this.datastoreService.parentDepartment;

    if (!this.parentDepartment) {
      let parentDepartment = await this.departmentService.getParentDepartment();
      this.datastoreService.parentDepartment = parentDepartment;
      this.parentDepartment = this.datastoreService.parentDepartment;
      const pId = parentDepartment.id;
      const pClient = parentDepartment.self.split('://')[1].split('.')[0];
      const token: any = await this.apiService.getToken(pClient, pId);
      if (token) {
        environment.clientToken = token.token;
      }
    }
    const pId = this.parentDepartment.id;
    const pClient = this.parentDepartment.self.split('://')[1].split('.')[0];
    const token: any = await this.apiService.getToken(pClient, pId);

    this.datastoreService.config = await this.apiService.getConfig(pClient, pId);
    this.spinner.show();
    this.selectedDepartment = this.datastoreService.selectedDepartment;
    let registrationOption = '';
    let organisationQuestionsID;

    // Set the title on the login page to the title from the business question
    this.parentDepartment.extra?.hasOwnProperty('permit_check_page_title')
      ? (this.pageTitle = this.parentDepartment.extra.permit_check_page_title)
      : (this.pageTitle = 'permit_check_page_title title not set');
    this.parentDepartment.extra?.hasOwnProperty('permit_check_page_guidance_text')
      ? (this.guidanceMsg =
        this.parentDepartment.extra.permit_check_page_guidance_text)
      : (this.guidanceMsg = 'permit_check_page_guidance_text not set');

    //     // Use this.departmentService.getLocation() if the services are set on the children departments
    //     // Use this.departmentService.get() if the services are set on the parent department
    this.departmentService.get().then(async (location) => {
      this.selectedLocation = location;

      //     // Get the selected service
      this.servicesService.get().then(async (service) => {
        this.selectedService = service;
        this.spinner.hide();
      });
    });
  }

  async sendVerification() {
    if (this.checkPermitForm) {

      this.spinner.show()
      this.sent = false
      const reg = this.checkPermitForm.value['registration']
      if (!reg) {
        return
      }
      const companyName = AppConfig.settings.apiServer.api_url
        .split('//')[1]
        .split('.council')[0];
      const res: any = await this.amazonService.checkPermitApplicationOperation(
        this.parentDepartment.id,
        companyName,
        '',
        'validateVehicleOnly',
        reg,
        '',
        ''
      );
      if (res.found) {
        if (res.record.status === "2") {

          await this.amazonService.sendVerificationEmail(
            this.randomString(6),
            JSON.parse(res.record.data).email_address,
            JSON.parse(res.record.data).first_name + " " + JSON.parse(res.record.data).last_name,
            reg)
          this.sent = true
        } else {
          const cpf = this.checkPermitForm.get('registration')
          console.log("cpf", cpf)
          if (cpf) {
            cpf.setErrors({
              regNotFound: "The permit for this vehicle registration cannot be amended or renewed.",
            });
          }

        }
      } else {
        const cpf = this.checkPermitForm.get('registration')
        console.log("cpf", cpf)
        if (cpf) {
          cpf.setErrors({
            regNotFound: "Registration not found",
          });
        }
      }
      console.log(res)
      this.spinner.hide()
    }
  }

  async verifyCode() {
    if (this.checkPermitForm) {

      this.spinner.show()
      this.checkPermitForm.controls['verificationCode'].setErrors({})
      this.showingHistory = false
      this.foundPermit = undefined
      const token = this.checkPermitForm.value['verificationCode']
      const req: any = await this.amazonService.verifyToken(token)
      console.log("req", req)
      if (req) {
        if (req.found) {
          const companyName = AppConfig.settings.apiServer.api_url
            .split('//')[1]
            .split('.council')[0];
          let mail: any = await this.amazonService.checkPermitApplicationOperation(
            this.parentDepartment.id,
            companyName,
            "",
            'get',
            "",
            "",
            "",
            "vehicle_registration",
            "",
            "",
            req.email.split("&&")[1]
          );
          console.log("mail", mail)
          if (mail) {
            if (mail[0]) {
              mail = mail[0]
              console.log(mail)
              const data = JSON.parse(mail.data)
              data['verificationCode'] = this.checkPermitForm.value['verificationCode']
              this.dataTablesData = JSON.parse(JSON.stringify(mail))
              console.log(data)
              console.log(this.checkPermitForm.controls)
              for (let key of Object.keys(data)) {
                this.dataTablesData[key] = JSON.parse(JSON.stringify(data[key]))
              }
              console.log(this.dataTablesData)
              const address = JSON.parse(JSON.stringify(this.dataTablesData.address))
              for (let key of Object.keys(address)) {
                if (!this.dataTablesData[key]) {
                  this.dataTablesData[key] = JSON.parse(JSON.stringify(address[key]))
                }
              }
              for (let key of Object.keys(this.dataTablesData)) {
                if (key.includes("date") || key === "valid_to") {
                  this.dataTablesData[key] = new Date(this.dataTablesData[key]).toLocaleDateString()
                }
                if (key === "status") {
                  this.dataTablesData['badge-colour'] = 'badge-secondary'

                  switch (this.dataTablesData[key]) {
                    case "0":
                      this.dataTablesData[key] = "Pending"
                      break;
                    case "1":
                      this.dataTablesData[key] = "Queried"
                      break;
                    case "2":
                      this.dataTablesData[key] = "Active"
                      this.dataTablesData['badge-colour'] = 'badge-success'
                      break;
                    case "3":
                      this.dataTablesData[key] = "Rejected"
                      this.dataTablesData['badge-colour'] = 'badge-danger'
                      break;
                    case "5":
                      this.dataTablesData[key] = "Revoked"
                      this.dataTablesData['badge-colour'] = 'badge-danger'
                      break;
                  }

                }
              }
              if (data.permit_type_6_visits_terms_and_conditions) {
                this.dataTablesData.type = "6 visit permit"
              } else {
                this.dataTablesData.type = "12 visit permit"
              }
              console.log(data)
              console.log(this.dataTablesData)
              console.log("data.is_your_vehicle_registered_in_the_UK", data.is_your_vehicle_registered_in_the_UK, data.is_your_vehicle_registered_in_the_UK === 'Yes')
              this.foundPermit = mail.permit_id

            }
          }
        } else {
          const cpf = this.checkPermitForm.get('verificationCode')
          if (cpf) {
            cpf.setErrors({ "codeNotFound": req.error })
          }
        }
      } else {
        const verificationCode = this.checkPermitForm.get('verificationCode')
        if (verificationCode) {
          verificationCode.setErrors({ "codeNotFound": "Code not found" })
        }
      }
      this.spinner.hide()
    }
  }

  async showAuditHistory() {
    try {
      this.spinner.show()

      this.history = []

      // get all bookings in the last 12 months for this email

      const clientUrl: any = await this.amazonService.getClientUrl(this.parentDepartment.id, this.dataTablesData.email_address)
      console.log("clientUrl", clientUrl)
      if (clientUrl.id) {
        const bookings: any = await this.amazonService.getAllBookings(this.parentDepartment.id, clientUrl.id)
        console.log("bookingsResult", bookings)
        for (let booking of bookings._embedded.bookings) {
          if (booking.questions) {
            if (booking.questions["39"]) {
              if (booking.current_multi_status === "checked_in" && booking.questions["39"].answer) {
                let dateTime = moment(`${booking.datetime}`, "YYYY-MM-DDTHH:mm:ssZ")
                this.history.push({
                  siteName: booking.company_name,
                  visitDate: dateTime.format("DD/MM/YYYY"),
                  visitTime: dateTime.format("HH:mm"),
                  visitMoment: dateTime
                })
              }
            }
          }
        }
        // get all no booking entries in the last 12 months for this registration
        const noBookings = await this.getAllNoBookings(this.dataTablesData.vehicle_reg, this.parentDepartment.id, null)
        console.log("noBookings", noBookings)
        for (let nb of noBookings.Items) {
          let visitMoment = moment(`${nb.date} ${nb.time}`, "YYYY-MM-DD HH:mm")
          this.history.push({
            siteName: nb.site_name,
            visitDate: visitMoment.format("DD/MM/YYYY"),
            visitTime: visitMoment.format("HH:mm"),
            visitMoment: visitMoment
          })
        }
        this.history = this.history.filter((h: any) => moment(h.visitMoment).isAfter(moment().subtract(12, 'months')))
        this.history = this.history.sort((a: any, b: any) => b.visitMoment - a.visitMoment)
        this.showingHistory = true;
      }
      this.spinner.hide();
    } catch (err) {
      console.log(err)
      this.spinner.hide();
    }
  }


  async getAllNoBookings(vehicle_reg: string, company: string, ExclusiveStartKey: any) {
    try {
      let url = `/company/${company.toString()}/nobooking/GSI?vehicle_reg_search=${vehicle_reg}`
      if (ExclusiveStartKey) {
        url += `&ExclusiveStartKey=${ExclusiveStartKey.id}&vehicle_reg=${ExclusiveStartKey.vehicle_reg}`
      }
      const result: any = await this.amazonService.getAllNoBookingsCall(url)
      console.log("getAllNoBookings result", result)
      if (result.LastEvaluatedKey) {
        const nextResult = await this.getAllNoBookings(vehicle_reg, company, result.LastEvaluatedKey)
        result.Items = result.Items.concat(nextResult.Items)
        result.LastEvaluatedKey = nextResult.LastEvaluatedKey
      }
      return result;
    } catch (error) {
      console.error("Error fetching no bookings:", error);
      throw error;
    }
  }

  randomString(length: number): string {

    var randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    var result: string = '';

    for (var i = 0; i < length; i++) {

      result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));

    }

    return result;
  }

  ngOnDestroy(): void {

  }


  // Scroll to the top of the page
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }

}
